import { styled, motion, Image, colors } from '../../styles/base/_allBase.styles'

export const HeaderDiv = styled(motion.header)`
  position: ${({ position }) => position || 'fixed'};
  inset: 0 0 auto;
  z-index: 100;
  width: 100%;
  min-height: 7.2rem;
  padding: 0 4vw;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-areas: 'left center right';
  align-items: center;
  background: rgba(244,241,233, 0.94);
  color: ${colors.warmPalette.primaryDark};
  border-bottom: 1px solid rgba(24,47,53, 0.12);
  box-shadow: 0 1rem 3rem rgba(24,47,53, 0.06);
  backdrop-filter: blur(14px);

  @media (max-width: 1023px) {
    min-height: 6.4rem;
    padding: 0 2rem;
    grid-template-columns: 1fr auto;
    grid-template-areas: 'left right';
  }
`

export const LeftGridItem = styled(motion.div)`grid-area:left; display:flex; align-items:center; justify-content:flex-start;`
export const CenterGridItem = styled(motion.div)`grid-area:center; min-width:0; @media (max-width:1023px){display:none;}`
export const RightGridItem = styled(motion.div)`grid-area:right; display:flex; justify-content:flex-end; align-items:center;`

export const ImgFullLogo = styled(motion(Image))`
  width: clamp(18rem, 17vw, 23rem);
  max-width: 100%;
  height: auto;
  display: block;
`

export const ItemDiv = styled(motion.button)`
  appearance:none; border:0; background:transparent; color:inherit; cursor:pointer;
  display:flex; align-items:center; gap:1rem; min-height:4.8rem; padding:.8rem 0 .8rem 1.6rem;
  text-transform:uppercase; letter-spacing:.08em;
  font-size:1.35rem; font-weight:700;
  span{display:inline-block;}
  svg{width:3.2rem;height:1.8rem;}

  @media(max-width:479px){
    gap:.7rem;
    padding-left:.8rem;
    span{font-size:1.2rem;}
    svg{width:2.8rem;}
  }
`

export const HeaderNav = styled.nav`
  display:flex; align-items:stretch; justify-content:center; gap:clamp(1.2rem, 1.8vw, 2.6rem);
  a { font-size:1.4rem; font-weight:600; display:flex; align-items:center; min-height:7.2rem; position:relative; }
  p { margin:0; font-size:1.45rem; font-weight:600; letter-spacing:.01em; }
  p::after { content:''; position:absolute; left:0; right:0; bottom:1.6rem; height:2px; background:${colors.warmPalette.secondary}; transform:scaleX(0); transform-origin:left; transition:transform .2s ease; }
  a:hover, a[aria-current] { text-decoration:underline; text-underline-offset:.8rem; }

  @media (min-width:1024px) and (max-width:1199px) {
    gap:1rem;
    a, summary { font-size:1.25rem; }
    p { font-size:1.18rem; }
  }
`

export const MotionLi = styled(motion.li)``

export const PlanningMenu = styled.details`
  position:relative; font-size:1.4rem; font-weight:600;
  summary { cursor:pointer; min-height:7.2rem; display:flex; align-items:center; gap:.6rem; }
  summary::after { content:'⌄'; }
  div { position:absolute; top:100%; left:-1.8rem; width:25rem; padding:1rem 1.8rem; background:white; border:1px solid ${colors.neutralPalette.greyLight}; border-radius:0 0 .6rem .6rem; box-shadow:0 1rem 2rem rgba(24,47,53,.1); }
  div a { min-height:4.4rem; }
`
